import { DateChartAnalytics } from '../../domain/analytics/dataChartAnalytics/DateChartAnalytics';
import { DateChartAnalyticsDTO } from '../../domain/analytics/dataChartAnalytics/DateChartAnalyticsDTO';

export class DateChartAnalyticsMapper {
  static toDomain(entry: DateChartAnalyticsDTO): DateChartAnalytics {
    return DateChartAnalytics.create(entry);
  }
}
